import { GridItem, LayoutGrid } from '@jouzen/ecom-components';
import { useState } from 'react';

import SectionHeading from '@/app/components/SectionHeading';

import popHighlightsFeatures from './data/popHighlightsFeatures';
import { PopHighlightsFeatureCarousel } from './PopHighlightsFeatureCarousel';
import { PopHighlightsFeatureList } from './PopHighlightsFeatureList';
import { PopHighlightsFeatureTabs } from './PopHighlightsFeatureTabs';
import { PopHighlightsRing } from './PopHighlightsRing';

export function PopHighlights(): JSX.Element {
  const [activeFeatureIndex, setActiveFeatureIndex] = useState<number>(0);
  const activeTooltip = popHighlightsFeatures[activeFeatureIndex]?.tooltip;

  return (
    <section className="relative pb-9 pt-16 lg:overflow-x-hidden lg:pb-16 lg:pt-32">
      <LayoutGrid className="lg:items-center xl:items-end">
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <SectionHeading
            animated
            className="mb-12"
            content="pop_highlights_title"
            multiline
            typographyProps={{
              className:
                'leading-heading mb-6 tracking-tighter lg:mb-4 text-center',
              color: 'inherit',
              Element: 'h2',
              variant: 'h2',
            }}
          />
        </GridItem>
        <GridItem
          className="hidden pb-20 xl:block"
          colEnd={{ lg: 9, xl: 8 }}
          colStart={{ lg: 'main' }}
        >
          <PopHighlightsFeatureTabs
            activeFeatureIndex={activeFeatureIndex}
            features={popHighlightsFeatures}
            onTabClick={setActiveFeatureIndex}
          />
        </GridItem>
        <GridItem
          colEnd={{ sm: 'main', md: 21, lg: 18 }}
          colStart={{ sm: 'main', md: 5, lg: 8 }}
        >
          <PopHighlightsRing tooltip={activeTooltip} />
        </GridItem>
        <GridItem
          className="xl:hidden"
          colEnd={{ sm: 'main', md: 21, lg: 'main' }}
          colStart={{ sm: 'main', md: 5, lg: 'main' }}
        >
          <PopHighlightsFeatureList features={popHighlightsFeatures} />
        </GridItem>
        <GridItem
          className="hidden xl:block"
          colEnd={{ lg: 'main' }}
          colStart={{ lg: 18, xl: 19 }}
        >
          <PopHighlightsFeatureCarousel
            activeFeatureIndex={activeFeatureIndex}
            features={popHighlightsFeatures}
            onSlideChange={setActiveFeatureIndex}
          />
        </GridItem>
      </LayoutGrid>
    </section>
  );
}
